<template>
  <section class="form-list">
    <div class="flex">
      <v-select-store
        v-if="isAdministrator"
        v-model="queryList.store_id"
        @input="RouteConfig.courseTodayList.push(queryList)"
        class="header-item"
      />
      <div class="header-item">
        已预约课程前后
        <v-input-number
          class="time-input"
          :is-plain="true"
          v-model="queryList.other_course_limit_time"
          type="unsignedSmallInt"
          placeholder=""
          @change="refresh"
        />
        分钟内其他门店课程的学员将被标记为红色
      </div>
    </div>
    <div class="student-container">
      <div class="box full-box">
        <div class="full-box-title">今日本店课卡预约其他门店课程概要：</div>
        <v-page-reservation-list :value="otherStoreReservations"/>
      </div>
      <div class="full-box full-box-title">今日本店课程预约概要：</div>
      <div class="box" v-for="v in list" :key="`course-item-${v.id}`">
        <router-link :to="RouteConfig.courseManage.to(v.id)" class="title-name primary-color">
          <span class="time">{{ v.start_time | timeToHi }}-{{ v.end_time | timeToHi }}</span>
          {{v.teacher_names}} {{v.course_name}}
        </router-link>
        <v-page-reservation-list :value="v"/>
      </div>
    </div>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getSignedStudents } from '@/api/course-reservation';
import { getTodayOtherStoreReservations } from '@/api/store';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.courseTodayList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isLoadingOtherStore: false,
    count: 0,
    list: [],
    otherStoreReservations: { students: [], isHideCountBar: true },
    queryList: {
      store_id: '',
      other_course_limit_time: 0,
    },
    course: {
      start_time: '',
      end_time: '',
    },
    timer: null,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  methods: {
    refresh(other_course_limit_time) {
      const queryList = Object.assign(this.queryList, { other_course_limit_time });
      RouteConfig.courseTodayList.push(queryList);
    },
    async getSignedStudents() {
      if (this.isLoading) return;
      this.isLoading = true;

      const { isError, data } = await getSignedStudents(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.list = data;
    },
    async getTodayOtherStoreReservations() {
      if (this.isLoadingOtherStore) return;
      this.isLoadingOtherStore = true;

      const { isError, data } = await getTodayOtherStoreReservations(this.queryList);
      this.isLoadingOtherStore = false;
      if (isError) return;

      this.otherStoreReservations.students = data;
    },
    load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);
      if (next) next();

      if (this.isAdministrator && !queryList.store_id) return;

      this.getSignedStudents();
      this.getTodayOtherStoreReservations();
    },
  },
  beforeMount() {
    this.load();
    this.timer = setInterval(this.load, 10000);
  },
  beforeRouteUpdate(to, from, next) {
    clearInterval(this.timer);
    this.load(to, next);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
  .app-container {
    padding: 16px;
  }

  .student-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 16px;
  }

  .box {
    box-sizing: border-box;
    width: 49%;
    padding-bottom: 50px;
  }

  .full-box {
    width: 100%;
  }

  /*.box:nth-child(2n - 1) {
    padding-right: 50px;
  }*/

  .full-box-title {
    display: flex;
    align-items: center;
    height: 64px;
    font-size: 26px;
    font-weight: bold;
  }

  .title-name {
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 18px;
    font-weight: bold;
  }

  .time {
    font-size: 24px;
    padding: 0 8px 2px 0;
  }

  .header-item {
    height: 40px;
    margin-right: 10px;
  }

  .time-input {
    width: 80px;
  }

</style>
